import { createApp } from 'vue'
import App from './App.vue'
import { installTarslogs } from './plugins/tarslogs'
import './assets/main.css'

const app = createApp(App)
installTarslogs(app)
app.mount('#app')
